import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { SaleController } from 'src/controllers/sale.controller'
import { CreateSaleDTO } from 'src/dto/sale'

const saleController = new SaleController()

export function useCreateSale() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['createSale', farmId],
    mutationFn: (createSaleDto: CreateSaleDTO) => saleController.createSale(farmId!, createSaleDto),
    onError: () => {
      toast.error('Erro ao criar venda.')
    }
  })
}
